<script>
  import { _ as t } from "svelte-i18n";

  import { Icon, Title, Calendar } from "t2c-components";
  import { getLanguage } from "i18n/language.js";

  export let item;
  export let cliccable = false;

  const iconColor = (icon) => {
    // https://coolors.co/0d1b2a-1b263b-415a77-778da9-e0e1dd
    switch (icon) {
      case "case":
        return "#aaa";
      case "document":
        return "#778da9";
      case "law":
        return "#1b263b";
      case "handshake":
        return "#415a77";
      default:
        return "#000";
    }
  };

  const tooltipText = (item) => {
    switch (item.__typename) {
      case "Lawcase":
        return $t("timeline.newCase");
      case "Event":
        if (item.category === "Judge") {
          return $t("timeline.newJudgeEvent");
        } else {
          return $t("timeline.newExtraEvent");
        }
      case "Document":
        return $t("timeline.newDocument");
    }
  };
</script>

<div class="wrapper" class:cliccable on:click>
  <div class="container">
    <div
      class="circle tooltip-right"
      data-tooltip={tooltipText(item)}
      style={`background-color: ${iconColor(item.icon)}`}
    >
      <Icon icon={item.icon} stroke="white" />
    </div>
    <div class="content">
      <Title compact>{item.title}</Title>
      <slot />
    </div>
  </div>
  <Calendar date={item.date} locale={$getLanguage} />
</div>

<style>
  .wrapper {
    position: relative;
    padding-bottom: 24px;
    border-left: 1px solid #aaa;
    display: flex;
    justify-content: space-between;
    margin-left: 24px;
    transition: background-color 0.3s ease-in-out;
  }

  .wrapper.cliccable {
    cursor: pointer;
  }

  .wrapper:hover {
    background-color: #f6f6f6;
  }

  .container {
    display: flex;
    margin-left: -24px;
  }

  .circle {
    position: absolute;
    width: 48px;
    height: 48px;
    border: 1px solid white;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content {
    margin-top: 8px;
    margin-left: 24px;
    padding-left: 48px;
  }
</style>
